
const digest = '94d22dd236a38c2d81dd60e2e80d298c4a4f3c4f803d77794281582bfcc89fca';
const classes = {"item":"_item_1ywda_1","cross":"_cross_1ywda_13","image":"_image_1ywda_16","name":"_name_1ywda_23","birthNumber":"_birthNumber_1ywda_28","badgeWrapper":"_badgeWrapper_1ywda_32","badges":"_badges_1ywda_37"};
const css = `._item_1ywda_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #aeb8cb;
  padding: 24px;
  align-items: center;
  cursor: pointer;
  position: relative;
  background-color: #ffffff;
  border-radius: 10px;
}
._item_1ywda_1 ._cross_1ywda_13 {
  height: 15px;
}
._item_1ywda_1 ._image_1ywda_16 img {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  margin-bottom: 15px;
  object-fit: cover;
}
._item_1ywda_1 ._name_1ywda_23 {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}
._item_1ywda_1 ._birthNumber_1ywda_28 {
  font-size: 14px;
  color: #787c88;
}
._item_1ywda_1 ._badgeWrapper_1ywda_32 {
  position: absolute;
  top: 0;
  left: 0;
}
._item_1ywda_1 ._badges_1ywda_37 {
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  